import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/index.vue";

import { getPayMsgApi } from "../api/index";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: Index,
  },
  {
    path: "/buy",
    name: "Buy",
    component: () => import("../views/buy.vue"),
  },
  {
    path: "/paySucceed",
    name: "PaySucceed",
    component: () => import("../views/paySucceed.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/tui/yygwx",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path === "/buy" || to.path === "/paySucceed") {
    let info = JSON.parse(localStorage.getItem("oneBuyUserInfo"));
    if (!info) {
      next(from.fullPath);
    }
    next();
  }
  next();
});

export default router;
